import { Ref } from 'vue';
import {
  FilterHistory,
  FilterSelectedValues,
} from '@/common/components/molecules/filterSearch/filterSearch.type';

interface UseFilterPersistenceParams {
  storageKey: string;
  getEnv: <T>(key: string | undefined) => Promise<T | null>;
  saveEnv: (key: string | undefined, value: any) => Promise<void>;
  convertToFilterSelectedValues: () => FilterSelectedValues;
  isFilterActive: Ref<boolean>;
  persistActiveState: boolean;
  filterHistory: Ref<FilterHistory[]>;
  pinnedTokenList: Ref<FilterSelectedValues | undefined>;
}

export function useFilterPersistence({
  storageKey,
  getEnv,
  saveEnv,
  convertToFilterSelectedValues,
  isFilterActive,
  persistActiveState,
  filterHistory,
  pinnedTokenList,
}: UseFilterPersistenceParams) {
  const saveFilterSelectedValues = async () => {
    await saveEnv(`${storageKey}--tokenList`, convertToFilterSelectedValues());
  };

  const removeFilterSelectedValues = async () => {
    await saveEnv(`${storageKey}--tokenList`, '');
  };

  const saveFilterActiveState = async () => {
    if (!persistActiveState) return;
    await saveEnv(`${storageKey}--isFilterActive`, isFilterActive.value);
  };

  const saveHistoryToEnv = async () => {
    await saveEnv(`${storageKey}--history`, filterHistory.value);
  };

  const loadEnvData = async () => {
    const savedTokenList = await getEnv<FilterSelectedValues>(`${storageKey}--tokenList`);
    if (savedTokenList) {
      pinnedTokenList.value = savedTokenList;
    }
    if (persistActiveState) {
      const savedIsFilterActive = await getEnv<boolean>(`${storageKey}--isFilterActive`);
      if (savedIsFilterActive != null) {
        isFilterActive.value = savedIsFilterActive;
      }
    }
    const savedFilterHistory = await getEnv<FilterHistory[]>(`${storageKey}--history`);
    if (savedFilterHistory) {
      filterHistory.value = savedFilterHistory;
    }
  };

  return {
    saveFilterSelectedValues,
    removeFilterSelectedValues,
    saveFilterActiveState,
    saveHistoryToEnv,
    loadEnvData,
  };
}
